const itemsData = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        {
          title: "类型: ",
          banding: "SendType",
          value: "短信",
          dataType: "Type",
          dataMap: {
            1: "短信",
            2: "邮箱",
            3: "微信"
          }
        },
        { title: "定制号码: ", banding: "SendTo", value: "" }
      ]
    },
    {
      rowList: [{ title: "定制功能: ", banding: "CustomizedStr", value: "" }]
    }
  ]
};
export {
  itemsData
}
